
import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { CreateCertificateDialog } from '@/components/admin/certificates/CreateCertificateDialog';
import { CertificateTypesList } from '@/components/admin/certificates/CertificateTypesList';

export function CertificatesManageContent() {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("types");
  
  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Certificate Management</h1>
        <Button onClick={() => setIsCreateDialogOpen(true)} className="flex items-center gap-2">
          <Plus className="h-4 w-4" />
          Create Certificate
        </Button>
      </div>
      
      <Tabs defaultValue="types" className="w-full" onValueChange={setActiveTab}>
        <TabsList className="grid grid-cols-2 w-[400px]">
          <TabsTrigger value="types">Certificate Types</TabsTrigger>
          <TabsTrigger value="issue">Issue Certificates</TabsTrigger>
        </TabsList>
        
        <TabsContent value="types" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Certificate Types</CardTitle>
              <CardDescription>Manage different certificate types</CardDescription>
            </CardHeader>
            <CardContent>
              <CertificateTypesList />
            </CardContent>
          </Card>
        </TabsContent>
        
        <TabsContent value="issue" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Issue New Certificate</CardTitle>
              <CardDescription>Create and issue certificates to users</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Click the "Create Certificate" button to issue a new certificate to a user.
              </p>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
      
      <CreateCertificateDialog open={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen} />
    </div>
  );
}
